import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/line_items/')({
    component: LineItems,
});

function LineItems() {
    return <Navigate to="/" />;
}
